import { lazyLoad } from 'utils/loadable';
import { SplashScreen } from 'app/components/ui/Splash';

export const Login = lazyLoad(
  () => import('./index'),
  module => module.Login,
  {
    fallback: <SplashScreen />,
  },
);
